import { Component, OnInit } from '@angular/core';
import { DariCalendarService } from '../../../services/DariCalendar';
import { ReportService } from '../../../services/Acc_ReportService';
import { MatSnackBar } from '@angular/material';
import * as $ from 'jquery'; import { last } from 'rxjs/operators'; import { GL_MasterService } from '../../../services/Acc_GL_Master.service';

@Component({
  selector: 'app-sum-money',
  templateUrl: './sum-money.component.html',
  styleUrls: ['./sum-money.component.css']
})
export class SumMoneyComponent implements OnInit {
  constructor(private GL_MasterService: GL_MasterService, private ReportService: ReportService, private DariCalendar: DariCalendarService, public snack: MatSnackBar) { }
  semester: string = "1";
  department: string;
  year: string;
  shift: string;
  season: string;
  departmentList: any = {}; years = new Array(); semesters = new Array();
  ngOnInit() {
    Array.from({ length: 30 }, (x, i) => this.years.push(i + 1380));
    Array.from({ length: 14 }, (x, i) => this.semesters.push(i + 1));
  }
  searchStudent() {
    this.ReportService.getSumMoney(this.semester, this.year, this.shift, this.season).subscribe(r => {
      this.departmentList = r;
      console.log(r);
    });
  }
  printReport() { }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/sum-money/sum-money.component.ts